import { jsx as _jsx } from "react/jsx-runtime";
import { RoundActionIconButton } from "./RoundActionIconButton";
export function ViewerButtons(props) {
    return (_jsx(RoundActionIconButton, Object.assign({}, props, { colorOnHover: true, baseColor: "#ffffff", baseBackgroundColor: "rgba(48, 48, 48, 0.3)" })));
}
